var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrongAnswer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3395 15.3433C14.9206 15.7641 14.3564 15.9981 13.7545 15.9981C13.1563 15.9981 12.5921 15.7641 12.1675 15.3414L8.00094 11.1711L3.83253 15.3414C3.40984 15.7641 2.84562 15.9981 2.24366 15.9981C1.64359 15.9981 1.08126 15.7641 0.656681 15.3395C0.237764 14.9206 0.00188702 14.3564 0 13.7601C0 13.1582 0.23399 12.5939 0.658568 12.1694L4.82698 7.99906L0.658568 3.83064C0.23399 3.40417 0 2.84184 0 2.24366C0 1.64359 0.235877 1.07937 0.660455 0.656681C1.07937 0.235877 1.63982 0.00188701 2.238 0H2.24366C2.84184 0 3.40606 0.232103 3.83064 0.656681L8.00094 4.82698L12.1675 0.656681C12.5921 0.232103 13.1563 0 13.7545 0H13.7563C14.3564 0 14.9206 0.23399 15.3433 0.658568C16.2151 1.52848 16.2151 2.95129 15.3433 3.82875L11.173 7.99906L15.3414 12.1694C15.766 12.5939 16 13.1563 16 13.7563C16 14.3545 15.766 14.9187 15.3395 15.3433Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrongAnswer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrong-answer.7bae1c096ec06f562746e999786ac055.svg";